import { render } from "./ThemesCreate.vue.js?vue&type=template&id=901c09a2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesCreate.vue?vue&type=template&id=901c09a2"
import script from "./ThemesCreate.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesCreate.vue?vue&type=script&lang=js"
export * from "./ThemesCreate.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/ThemesCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "901c09a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('901c09a2', __exports__)) {
    api.reload('901c09a2', __exports__)
  }
  
  module.hot.accept("./ThemesCreate.vue.js?vue&type=template&id=901c09a2!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemesCreate.vue?vue&type=template&id=901c09a2", () => {
    api.rerender('901c09a2', render)
  })

}


export default __exports__